import { ajaxGet, ajaxFileGet, ajaxPut, ajaxDelete } from "../data/ajax";
import { ConvertableFromApi } from "./ConvertableFromApi";
import { Helper } from "../models/HelperClasses";

export class VirtualMachine extends ConvertableFromApi<VirtualMachine> {
    publicIp!: string;
    name!: string;
    friendlyName!: string;
    powerState: string;
    actualPowerState: string;
    vmSize!: string;
    tags: any;
    changingSize: boolean = false;
    backgroundColor!: string;
    currentSizeAndPrice?: SizeAndPrice;
    sizes!: SizeAndPrice[];
    description!: string;
    autoShutdownSchedule!: AutoShutdownSchedule;
    autoShutdownCPUSchedule!: AutoShutdownCPUSchedule;
    isLinux!: boolean;

    stateUpdated: boolean = false;
    stateUpdatedAt: number = 0;

    updatingDescriptionTag: boolean = false;
    changingAutoShutdownSchedule: boolean = false;
    changingAutoShutdownCPUSchedule: boolean = false;

    constructor(data?: any) {
        super(data);
        if (!this.objectFromApi) {
            return;
        }

        this.publicIp = this.objectFromApi.publicIp;
        this.name = this.objectFromApi.name;
        this.friendlyName = this.objectFromApi.friendlyName;
        this.powerState = this.objectFromApi.powerState;
        this.actualPowerState = this.objectFromApi.powerState;
        this.setBackgroundColor();
        this.vmSize = this.objectFromApi.vmSize;
        this.tags = this.objectFromApi.tags;
        if (this.tags)
            this.description = this.objectFromApi.tags.Description ? this.objectFromApi.tags.Description : ' ';
        this.isLinux = this.objectFromApi.isLinux;
        this.currentSizeAndPrice = this.objectFromApi.currentSizeAndPrice;
        this.sizes = [];
        this.autoShutdownSchedule = this.objectFromApi.autoShutdownSchedule;
        this.autoShutdownCPUSchedule = this.objectFromApi.autoShutdownCPUSchedule;
        if (this.objectFromApi.schedule) {
            this.autoShutdownSchedule = new AutoShutdownSchedule();
            this.autoShutdownSchedule.autoShutdownTime = this.objectFromApi.schedule.time.substring(0, 2) + ":" + this.objectFromApi.schedule.time.substring(2, 4);
            this.autoShutdownSchedule.autoShutdownEnabled = this.objectFromApi.schedule.enabled;
        }
        if (this.objectFromApi.cpuSchedule) {
            this.autoShutdownCPUSchedule = new AutoShutdownCPUSchedule();
            this.autoShutdownCPUSchedule.cpuPercentage = this.objectFromApi.cpuSchedule.cpuPercentage;
            this.autoShutdownCPUSchedule.intervalInHours = this.objectFromApi.cpuSchedule.intervalInHours;
            this.autoShutdownCPUSchedule.autoShutdownEnabled = this.objectFromApi.cpuSchedule.enabled;
        }
        if (this.objectFromApi.sizes !== undefined) {
            this.objectFromApi.sizes.forEach((size: any) => {
                this.sizes.push(new SizeAndPrice(size));
            });
        }
    }

    createNew(element: any): VirtualMachine {
        return new VirtualMachine(element);
    }

    public setBackgroundColor(): void {
        if (this.powerState === 'VM deallocated') {
            this.backgroundColor = '#C60C30'; //red
        }
        else if (this.powerState === 'VM running') {
            this.backgroundColor = '#3F9C35'; //green
        }
        else {
            this.backgroundColor = '#EC7A08'; //orange
        }
    }

    public async getRdp(resourceGroupName: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/Rdp/${resourceGroupName}/${this.publicIp}`;
        var file = await ajaxFileGet(url, token);
        if (file !== null) {
            var a = document.createElement('a');
            var url2 = window.URL.createObjectURL(file);
            a.href = url2;
            a.download = `${this.friendlyName}.rdp`;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }

    public async updateVm(workspaceName: string, subscriptionId: string, vmaction: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/${workspaceName}/subscription/${subscriptionId}/virtualMachine/${this.name}/update/${vmaction}`;
        return await ajaxGet(url, token);
    }

    public async updateVmAutoShutdownSchedule(subscriptionId: string, workspaceName: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/${workspaceName}/subscription/${subscriptionId}/virtualMachine/${this.name}/updateAutoShutdownSchedule`;
        var schedule = {
            enabled: this.autoShutdownSchedule.autoShutdownEnabled,
            time: this.autoShutdownSchedule.autoShutdownTime.substring(0, 2) + this.autoShutdownSchedule.autoShutdownTime.substring(3, 5)
        }
        return await ajaxPut(url, token, schedule);
    }
    public async updateDescriptionTag(subscriptionId: string, workspaceName: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/${workspaceName}/subscription/${subscriptionId}/virtualMachine/${this.name}/updateDescriptionTag`;
        var updateDescription = {
            VmDescription: this.description
        }
        return await ajaxPut(url, token, updateDescription);
    }
    public async updateVmAutoShutdownCPUSchedule(subscriptionId: string, workspaceName: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/${workspaceName}/subscription/${subscriptionId}/virtualMachine/${this.name}/updateAutoShutdownCPUSchedule`;
        var schedule = {
            enabled: this.autoShutdownCPUSchedule.autoShutdownEnabled,
            cpuPercentage: parseFloat(this.autoShutdownCPUSchedule.cpuPercentage.toString()),
            intervalInHours: parseInt(this.autoShutdownCPUSchedule.intervalInHours.toString())
        }
        return await ajaxPut(url, token, schedule);
    }

    public async scaleVirtualMachine(workspaceName: string, subscriptionId: string, token: string) {
        const url = process.env.VUE_APP_ROOT_API + `Workspace/${workspaceName}/subscription/${subscriptionId}/virtualMachine/${this.name}/scale/${this.vmSize}`;
        return await ajaxGet(url, token);
    }

    public async remove(workspaceName: string, subscriptionId: string, token: string) {
        const url =
            process.env.VUE_APP_ROOT_API +
            `Workspace/${workspaceName}/subscription/${subscriptionId}/removeVirtualMachine/${this.name}`;
        return await ajaxDelete(url, token);
    }

    public updateState(state: string) {
        this.powerState = state;
        this.actualPowerState = state;
        this.setBackgroundColor();
        this.stateUpdated = true;
        this.stateUpdatedAt = Date.now();
        this.log()
    }

    public getSizeNames(): string {
        if (!this.sizes)
            return "none";
        return this.sizes.map((s: SizeAndPrice) => s.technicalName.toLocaleLowerCase()).join(",");
    }

    public setSize() {
        if (!this.vmSize || !this.sizes || this.sizes.length == 0) {
            this.log("VM size or sizetypes not set");
            return;
        }

        const vmSizeName = this.vmSize.toLowerCase();
        this.currentSizeAndPrice = this.sizes.find((s: SizeAndPrice) => s.technicalName.toLocaleLowerCase() === vmSizeName);
        if (!this.currentSizeAndPrice) {
            const sizeNames = this.getSizeNames();
            this.log("VM size", vmSizeName, "not found in", sizeNames);
        }
    }

    public fixVmSize(oldVm: VirtualMachine) {
        this.setSize();
        // if backend returns empty list (because of ongoing operation)
        // use sizes from the prev VM state
        if (oldVm && (!this.sizes || this.sizes.length == 0) && (oldVm.sizes && oldVm.sizes.length > 0) && this.powerState !== "Creating") {
            this.log("reuse old VM sizes:", oldVm.getSizeNames());
            this.sizes = oldVm.sizes;
        }
    }

    // must be static to allow mutations of store's data-only VM object
    public static fixUpdateState(vm: VirtualMachine, oldVm: VirtualMachine, vmUpdateStateHoldInterval: number): boolean {
        if (!oldVm.stateUpdated || oldVm.powerState === vm.powerState)
            return false;
        if (Date.now() - oldVm.stateUpdatedAt > vmUpdateStateHoldInterval) {
            oldVm.log("on hold canceled, now", vm.powerState);
            return false;
        }

        oldVm.log("on hold, actual", vm.powerState);
        vm.powerState = oldVm.powerState;
        vm.stateUpdatedAt = oldVm.stateUpdatedAt;
        return true;
    }

    public log(...args: any[]) {
        const s = this.powerState === this.actualPowerState ? "" : "(" + this.actualPowerState + ")";
        Helper.log("VM", this.name, this.timestamp, this.powerState, s, ...args);
    }
}

export class SizeAndPrice {
    numberOfCores: number;
    technicalName: string;
    displayName: string;
    pricePerMonthInEuro: number;
    pricePerHour: number;
    memoryInMB: number;
    visible: boolean;
    cluster: number;

    constructor(apiObject: any) {
        this.numberOfCores = apiObject.numberOfCores;
        this.technicalName = apiObject.technicalName;
        this.displayName = apiObject.displayName;
        this.pricePerMonthInEuro = apiObject.pricePerMonthInEuro;
        this.pricePerHour = this.pricePerMonthInEuro / 729.77; //This is the ratio Azure uses
        this.memoryInMB = apiObject.memoryInMB;
        this.visible = apiObject.visible;
        this.cluster = apiObject.cluster;
    }
}

export class VmImage {
    id: string;
    displayName: string;
    componentFile: string;
    defaultSizeTechnicalName: string;

    constructor(apiObject: any) {
        this.componentFile = apiObject.componentFile;
        this.displayName = apiObject.displayName;
        this.id = apiObject.id;
        this.defaultSizeTechnicalName = apiObject.defaultSizeTechnicalName;
    }
}

class AutoShutdownSchedule {
    autoShutdownEnabled!: boolean;
    autoShutdownTime!: string;
}

class AutoShutdownCPUSchedule {
    autoShutdownEnabled!: boolean;
    cpuPercentage!: number;
    intervalInHours!: number;
}